<mat-label>Select Company<span *ngIf="required" class="text-danger">*</span></mat-label>
<mat-select [formControl]="companyFormControl" placeholder="Select Company">
    <ng-container *ngFor="let companyName of companies">
        <mat-option [value]="companyName">{{companyName | uppercase}}</mat-option>
    </ng-container>
</mat-select>